// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__YwqB_","loaderOuter":"PageOverlayLoader_loaderOuter__2PRq9"};